var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"assignment"},[_c('h6',{staticClass:"assignment-title"},[_vm._v("\n        "+_vm._s(_vm.lpAssignmentIn.name)+"\n    ")]),_vm._v(" "),_c('b-badge',{staticClass:"assignment-lp-category",attrs:{"pill":"","variant":"info"}},[_vm._v("\n        "+_vm._s(_vm.lpAssignmentIn.lp_category.name)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }